var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnblockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9198 4.06134C12.5661 3.04593 11.865 2.18809 10.9404 1.63919C10.0158 1.0903 8.92702 0.885629 7.86621 1.06131C6.80541 1.237 5.84086 1.78173 5.14258 2.5994C4.4443 3.41706 4.05727 4.45511 4.0498 5.53034V7.69934",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4301 19.5H4.79004C3.78459 19.4992 2.82054 19.0992 2.10986 18.388C1.39919 17.6767 1 16.7124 1 15.707V11.419C1 10.4135 1.39919 9.44922 2.10986 8.73798C2.82054 8.02674 3.78459 7.62677 4.79004 7.62598H12.4301C13.4367 7.62597 14.4021 8.02536 15.1145 8.73648C15.8269 9.44761 16.2281 10.4124 16.23 11.419V15.707C16.2281 16.7136 15.8269 17.6783 15.1145 18.3895C14.4021 19.1006 13.4367 19.5 12.4301 19.5V19.5Z",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60986 12.4531V14.6751",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnblockIcon);
export default __webpack_public_path__ + "static/media/unblock-icon.0efbf21897974453765b218d11a9c22c.svg";
export { ForwardRef as ReactComponent };